export default "__VITE_ASSET__Dd3tjKzy__"